import type { ReactNode } from 'react'

export const Button = ({
  children,
  variant,
  onClick,
  className = '',
  disabled = false,
  icon,
}: {
  children: ReactNode
  onClick?: () => void
  className?: string
  variant: 'primary' | 'secondary' | 'ghost'
  disabled?: boolean
  icon?: ReactNode
}) => {
  const buttonVariant = () => {
    if (disabled) return 'ap:text-content-disabled ap:bg-surface-disabled'

    switch (variant) {
      case 'primary':
        return 'ap:bg-primary ap:text-content-inverse ap:hover:bg-secondary ap:border ap:border-transparent'
      case 'secondary':
        return 'ap:bg-surface-accent-dark ap:text-content-button ap:hover:bg-surface-accent-dark-hover ap:border ap:border-transparent'
      case 'ghost':
        return 'ap:bg-surface-background ap:border ap:border-stroke-primary ap:text-content-primary ap:hover:bg-surface-primary-hover'
      default:
        return 'ap:text-lg ap:font-semibold ap:text-content-primary'
    }
  }
  const buttonClass = buttonVariant()

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${buttonClass} ${className} ap:px-xl ap:py-sm ap:gap-md ap:text-sm ap:text-nowrap ap:rounded-sm ap:font-semibold ap:flex ap:items-center ap:justify-center ap:transition-all ap:ease-in-out ap:w-fit ap:h-fit ${disabled ? 'ap:cursor-not-allowed' : 'ap:cursor-pointer'}`}
    >
      {icon && <span className="ap:flex ap:items-start">{icon}</span>}
      {children}
    </button>
  )
}
